import { IconArrowLeft } from "@tabler/icons";
import { Button } from "@mui/material";

/**
 * "Back to the list", above a page header.
 *
 * It was a bare `<div>` with a `d-flex` Bootstrap class the panel does not
 * load, an 18px label and a hover that only greyed the text - a control that
 * did not look like one. It is a quiet text button now.
 */
export default function BackButton({ text, onClick }) {
  return (
    <Button
      variant="text"
      size="small"
      onClick={onClick}
      startIcon={<IconArrowLeft size="1.05rem" />}
      sx={{ mb: 1.5, ml: -1, color: "text.secondary", fontWeight: 500 }}
    >
      {text}
    </Button>
  );
}
